import React from "react"
import { Navbar } from "../../components/navbar/Navbar"
import { Sidebar } from "../../components/sidebar/Sidebar"
import { Chart } from "../../components/charts/chart/Chart"
import "./single.scss"
import { List } from "../../components/table/Table"

export const Single = () => {
	return (
		<div className="single">
			<Sidebar />
			<div className="singleContainer">
				<Navbar />
				<div className="top">
					<div className="left">
						<div className="editButton">Edit</div>
						<h1 className="title">Information</h1>
						<div className="item">
							<img
								src="https://images.pexels.com/photos/4355346/pexels-photo-4355346.jpeg?cs=srgb&dl=pexels-murat-esibatir-4355346.jpg&fm=jpg"
								alt="avatar"
								className="itemImg"
							/>
							<div className="details">
								<h1 className="detailTitle">Jane Doe</h1>
								<div className="detailItem">
									<span className="itemKey">Email:</span>
									<span className="itemValue">janedoe@gmail.com</span>
								</div>
								<div className="detailItem">
									<span className="itemKey">Phone:</span>
									<span className="itemValue">+1 213 546 4785</span>
								</div>
								<div className="detailItem">
									<span className="itemKey">Address:</span>
									<span className="itemValue">
										Elton St. 234 Garden Yd. New York City
									</span>
								</div>
								<div className="detailItem">
									<span className="itemKey">Country:</span>
									<span className="itemValue">USA</span>
								</div>
							</div>
						</div>
					</div>
					<div className="right">
						<Chart aspect={5 / 1} title="User Spending (Last 6 Months)" />
					</div>
				</div>
				<div className="bottom">
					<h1 className="title">Last Transactions</h1>

					<List />
				</div>
			</div>
		</div>
	)
}
